<template>
  <NotificationGroup
      group="bottom"
  >
    <div class="fixed inset-x-0 bottom-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none">
      <div class="w-full max-w-sm">
        <Notification
            v-slot="{ notifications }"
            enter="ease-out duration-300 transition"
            enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
            enter-to="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-500"
            leave-from="opacity-100"
            leave-to="opacity-0"
            move="transition duration-500"
            move-delay="delay-300"
        >
          <div
              v-for="notification in notifications"
              :key="notification.id"
              class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md"
          >
            <transition enter-active-class="transform ease-out duration-300 transition"
                        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                        leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                        leave-to-class="opacity-0">
              <div v-if="show"
                   class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div class="p-4">
                  <div class="flex items-start">
                    <div class="flex-shrink-0">
                      <CheckCircleIcon v-if="notification.type === 'success'" class="h-10 w-10 text-green-400"
                                       aria-hidden="true"/>
                      <ExclamationCircleIcon v-if="notification.type === 'error'" class="h-10 w-10 text-warning"
                                             aria-hidden="true"/>
                    </div>
                    <div class="ml-3 w-0 flex-1 pt-0.5">
                      <p class="text-base font-medium text-gray-900">{{ notification.title }}</p>
                      <p class="mt-1 text-sm text-gray-500">{{ notification.text }}</p>
                    </div>
                    <div class="ml-4 flex-shrink-0 flex">
                      <button type="button" @click="show = false"
                              class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <span class="sr-only">Close</span>
                        <XIcon class="h-5 w-5" aria-hidden="true"/>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </Notification>
      </div>
    </div>
  </NotificationGroup>
  <div v-if="invoiceData">
    <div class="md:grid md:grid-cols-3 md:gap-4">
      <div class="md:col-span-2">

        <!-- Conteneur au ratio A4 : le visualiseur n'a plus de bandes latérales sombres -->
        <div id="pdfvuer" class="shadow overflow-hidden" style="aspect-ratio: 210 / 297" v-if="invoiceData.id">
          <embed :src="`https://billing.clafoutis.eu/api/file/${invoiceData.id}#toolbar=0&navpanes=0&view=Fit`"
                 class="h-full w-full"
                 type='application/pdf'/>
          <!--          <pdf :src="pdfdata"  v-for="i in numPages" :key="i" :id="i" :page="i"-->
          <!--               v-model:scale="scale" style="width:100%;"-->
          <!--               :annotation="true"-->
          <!--               :resize="true"-->
          <!--               @link-clicked="handle_pdf_link">-->
          <!--            <template>-->
          <!--              loading content here...-->
          <!--            </template>-->
          <!--          </pdf>-->
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-1">

        <form action="" method="post" @submit.prevent="postNow" @keyup.enter="postNow" @input="stopPull">
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="bg-white border-b border-gray-200 px-4 py-3">
              <div class="flex items-center gap-2" v-if="previousInvoice || nextInvoice || siblingOptions.length">
                <router-link v-if="previousInvoice" :to="`/invoice/${previousInvoice.id}`"
                             :title="`Précédente : ${siblingLabel(previousInvoice)}`"
                             class="shrink-0 rounded-md border border-gray-300 px-2.5 py-1.5 text-sm text-gray-600 hover:bg-gray-50">←</router-link>
                <span v-else class="shrink-0 rounded-md border border-gray-100 px-2.5 py-1.5 text-sm text-gray-300">←</span>

                <select v-if="siblingOptions.length" :value="invoiceData.id" @change="goToInvoice($event.target.value)"
                        class="min-w-0 flex-1 rounded-md border border-gray-300 py-1.5 text-sm text-gray-700 focus:border-indigo-500 focus:ring-indigo-500">
                  <option v-for="s in siblingOptions" :key="s.id" :value="s.id">{{ siblingLabel(s) }}</option>
                </select>

                <router-link v-if="nextInvoice" :to="`/invoice/${nextInvoice.id}`"
                             :title="`Suivante : ${siblingLabel(nextInvoice)}`"
                             class="shrink-0 rounded-md border border-gray-300 px-2.5 py-1.5 text-sm text-gray-600 hover:bg-gray-50">→</router-link>
                <span v-else class="shrink-0 rounded-md border border-gray-100 px-2.5 py-1.5 text-sm text-gray-300">→</span>
              </div>
            </div>
            <div class="relative bg-white px-4 py-5 border-b border-gray-200 sm:px-6" v-if="invoiceData.company">
              <!-- Indicateur d'enregistrement : positionné en absolu pour ne pas décaler le titre -->
              <span title="État de l'enregistrement" class="absolute right-3 top-3">
                <svg v-if="changeInProgress" class="animate-spin h-5 w-5 text-indigo-500"
                     xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <CheckCircleIcon v-else class="h-5 w-5 text-indigo-500" aria-hidden="true"/>
              </span>
              <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                <div class="ml-4 mt-4">
                  <div class="flex items-center">
                    <div class="flex-shrink-0" v-if="invoiceData.company.avatar">
                      <router-link :to="`/company/${invoiceData.company ? invoiceData.company.id : null}`">
                        <img class="h-12 w-12 rounded-full"
                             :src="invoiceData.company ? invoiceData.company.avatar : null" alt=""/>
                      </router-link>
                    </div>
                    <div class="ml-4">
                      <h3 class="text-lg leading-6 font-medium text-gray-900">
                        {{ invoiceData.company ? invoiceData.company.name : null }}
                        <button type="button" title="Copier le nom"
                                @click="copyToClipboard(invoiceData.company ? invoiceData.company.name : null, 'Nom du fournisseur')"
                                class="ml-1 text-gray-400 hover:text-indigo-600 align-middle">
                          <ClipboardCopyIcon class="h-4 w-4 inline"/>
                        </button>
                      </h3>
                      <p class="text-sm text-gray-500" v-if="invoiceData.company.description">
                        <a href="#">{{
                            invoiceData.company ? invoiceData.company.description.substring(0, 90) : null
                          }}</a>
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="px-4 py-5 bg-white sm:p-5">

              <div class="grid grid-cols-2 gap-2">
                <div class="col-span-2 sm:col-span-2 ">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Fournisseur</label>
                  <Multiselect v-if="companys.length"
                               v-model="invoiceData.company_id"
                               placeholder="Select options"
                               :options="companys"
                               :create-option="true"
                               label="label"
                               valueProp="value"
                               :allow-absent="true"
                               :searchable="true"
                               :object="false"
                               :close-on-select="true"
                               :min-chars="1"
                               @change=postNow
                               @blur=postNow
                               @close=postNow
                               @select=postNow
                  >
                    <template v-slot:option="{ option }">
                      <img class="character-option-icon h-5 w-5 flex-shrink-0 rounded-full" :src="option.icon">
                      <span class="font-normal ml-3 block truncate">{{ option.label }}</span>
                    </template>
                  </Multiselect>

                </div>
                <div class="col-span-2 sm:col-span-2">
                  <div class="flex items-center justify-between">
                    <h3 class="text-sm text-gray-900 font-medium">Status</h3>
                  </div>

                  <RadioGroup v-model="invoiceData.status_id" class="mt-2" @click=postNow>
                    <div class="grid gap-2 grid-cols-2 sm:grid-cols-3 lg:grid-cols-3">
                      <RadioGroupOption as="template" :key="status.id" v-for="status in invoiceData.available_status"
                                        :value="status.id" :disabled="status.disabled" v-slot="{ active, checked }"
                      >
                        <div
                            :class="[ 'cursor-pointer focus:outline-none min-w-0', active ? 'ring-2 ring-offset-2 ring-indigo-500' : '', checked ? 'bg-indigo-600 border-transparent text-white hover:bg-indigo-700' : 'bg-white border-gray-200 text-gray-900 hover:bg-gray-50', 'border rounded-md py-2 px-1 flex items-center justify-center text-center text-xs font-medium uppercase break-words sm:flex-1']">
                          <RadioGroupLabel as="span">
                            {{ status.name }}
                          </RadioGroupLabel>
                        </div>
                      </RadioGroupOption>
                    </div>
                  </RadioGroup>

                </div>

                <div class="col-span-2 sm:col-span-2" v-if="invoiceData.id && isTelecomInvoice">
                  <PhoneLineInvoicePanel :invoice-id="invoiceData.id" />
                </div>

                <div class="col-span-1 sm:col-span-1" v-if="invoiceData.status_id!==4">
                  <label class="block text-sm font-medium text-gray-700 ">Montant
                    <button type="button" title="Copier le montant"
                            @click="copyToClipboard(invoiceData.amount, 'Montant')"
                            class="ml-1 text-gray-400 hover:text-indigo-600 align-middle">
                      <ClipboardCopyIcon class="h-4 w-4 inline"/>
                    </button>
                  </label>
                  <input type="text" v-model.number="invoiceData.amount" @change=postNow
                         :class="invoiceData.amount <= transactions_total_amount ? 'mt-1 border-green-600 border-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md' :  'border-red-600 border-2 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md'"


                  />
                </div>

                <div class="col-span-1 sm:col-span-1" v-if="invoiceData.status_id!==4">
                  <label class="block text-sm font-medium text-gray-700">Taxe
                    <button type="button" title="Copier la taxe"
                            @click="copyToClipboard(invoiceData.amount_tax, 'Taxe')"
                            class="ml-1 text-gray-400 hover:text-indigo-600 align-middle">
                      <ClipboardCopyIcon class="h-4 w-4 inline"/>
                    </button>
                  </label>
                  <div class="mt-1 grid grid-cols-2 gap-1">
                    <input type="text" v-model.number="invoiceData.amount_tax" @change=postNow
                           class="focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border"/>
                    <div class="flex items-center justify-center truncate rounded-md border border-gray-300 bg-gray-50 px-2 text-sm text-gray-600"
                         title="Taux de TVA et devise détectés par Mindee">
                      {{ taxMeta || '—' }}
                    </div>
                  </div>
                </div>

                <div class="col-span-2 sm:col-span-2" v-if="invoiceData.status_id!==4 && invoiceData.billing_account">
                  <div class="grid grid-cols-4 gap-2">
                    <div class="col-span-1">
                      <label class="block text-sm font-medium text-gray-700">Compte</label>
                      <div class="mt-1 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md px-3 py-2 bg-gray-50 text-center">
                        {{ invoiceData.billing_account.id }}
                      </div>
                    </div>
                    <div class="col-span-3">
                      <label class="block text-sm font-medium text-gray-700">Description</label>
                      <div class="mt-1 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md px-3 py-2 bg-gray-50">
                        {{ invoiceData.billing_account.name }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-span-1 sm:col-span-1" v-if="invoiceData.status_id!==4">
                  <label class="block text-sm font-medium text-gray-700">Date
                    <button type="button" title="Copier la date"
                            @click="copyToClipboard(invoiceData.date, 'Date')"
                            class="ml-1 text-gray-400 hover:text-indigo-600 align-middle">
                      <ClipboardCopyIcon class="h-4 w-4 inline"/>
                    </button>
                  </label>
                  <input type="text" v-model="invoiceData.date" @change=postNow
                         class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                </div>

                <div class="col-span-1 sm:col-span-1">
                  <label for="fiscal-year" class="block text-sm font-medium text-gray-700">Exercice comptable</label>
                  <select id="fiscal-year" name="fiscal-year" v-model="invoiceData.fiscal_year_id"
                          @change=postNow
                          class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                    <option v-for="year in fiscalYears" :key="year.id" :value="year.id"
                            :selected="invoiceData.fiscal_year_id === year.id">{{ year.name }}
                    </option>
                  </select>
                </div>

                <div class="col-span-2 sm:col-span-2" v-if="invoiceData.status_id!==4">
                  <label class="block text-sm font-medium text-gray-700">Transactions
                    ({{ transactions_total_amount }})</label>

                  <div v-if="transactionSuggestions.length"
                       class="mt-1 rounded-md border border-indigo-200 bg-indigo-50 px-2 py-1.5">
                    <p class="text-xs font-semibold uppercase tracking-wide text-indigo-700">
                      Suggestions — montant identique ({{ invoiceData.amount }} EUR)
                    </p>
                    <ul class="divide-y divide-indigo-100">
                      <li v-for="suggestion in transactionSuggestions" :key="suggestion.transaction.id"
                          class="flex items-center gap-2 py-1.5">
                        <img v-if="suggestion.transaction.company && suggestion.transaction.company.avatar" alt=""
                             :src="suggestion.transaction.company.avatar"
                             class="h-6 w-6 shrink-0 rounded-full bg-gray-200"/>
                        <div class="min-w-0 flex-1">
                          <p class="truncate text-sm font-medium text-gray-900">
                            {{ suggestion.transaction.from_name }}
                          </p>
                          <p class="truncate text-xs text-gray-600">
                            {{ suggestion.transaction.amount }} EUR
                            <span v-if="suggestion.matchedOnLocal" class="font-medium text-indigo-700">
                              ({{ suggestion.transaction.local_amount }} {{ suggestion.transaction.local_currency }})
                            </span>
                            · {{ String(suggestion.transaction.date).substr(0, 10) }}
                            · écart {{ suggestion.dayGap }} j
                          </p>
                        </div>
                        <button type="button" @click="applySuggestion(suggestion.transaction)"
                                class="shrink-0 rounded-md bg-indigo-600 px-2 py-1 text-xs font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1">
                          Associer
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div v-if="fxTransactionSuggestions.length"
                       class="mt-1 rounded-md border border-sky-200 bg-sky-50 px-2 py-1.5">
                    <p class="text-xs font-semibold uppercase tracking-wide text-sky-700">
                      Même fournisseur — écart de change probable
                    </p>
                    <ul class="divide-y divide-sky-100">
                      <li v-for="suggestion in fxTransactionSuggestions" :key="suggestion.transaction.id"
                          class="flex items-center gap-2 py-1.5">
                        <img v-if="suggestion.transaction.company && suggestion.transaction.company.avatar" alt=""
                             :src="suggestion.transaction.company.avatar"
                             class="h-6 w-6 shrink-0 rounded-full bg-gray-200"/>
                        <div class="min-w-0 flex-1">
                          <p class="truncate text-sm font-medium text-gray-900">
                            {{ suggestion.transaction.from_name }}
                          </p>
                          <p class="truncate text-xs text-gray-600">
                            {{ suggestion.transaction.amount }} EUR
                            · écart {{ suggestion.gapPercent }} %
                            · {{ String(suggestion.transaction.date).substr(0, 10) }}
                            · {{ suggestion.dayGap }} j
                          </p>
                          <p class="truncate text-xs font-medium text-sky-700">
                            Facture recalée {{ invoiceData.amount }} → {{ suggestion.newAmount }} €
                          </p>
                        </div>
                        <button type="button" @click="applyFxSuggestion(suggestion)"
                                class="shrink-0 rounded-md bg-sky-600 px-2 py-1 text-xs font-medium text-white hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-1">
                          Associer et corriger
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div v-if="companyTransactionSuggestions.length"
                       class="mt-1 rounded-md border border-gray-200 bg-gray-50 px-2 py-1.5">
                    <p class="text-xs font-semibold uppercase tracking-wide text-gray-600">
                      Même fournisseur — transactions non attribuées
                    </p>
                    <ul class="divide-y divide-gray-200">
                      <li v-for="suggestion in companyTransactionSuggestions" :key="suggestion.transaction.id"
                          class="flex items-center gap-2 py-1.5">
                        <img v-if="suggestion.transaction.company && suggestion.transaction.company.avatar" alt=""
                             :src="suggestion.transaction.company.avatar"
                             class="h-6 w-6 shrink-0 rounded-full bg-gray-200"/>
                        <div class="min-w-0 flex-1">
                          <p class="truncate text-sm font-medium text-gray-900">
                            {{ suggestion.transaction.from_name }}
                          </p>
                          <p class="truncate text-xs text-gray-600">
                            {{ suggestion.transaction.amount }} EUR
                            <span v-if="suggestion.transaction.local_amount != suggestion.transaction.amount">
                              ({{ suggestion.transaction.local_amount }} {{ suggestion.transaction.local_currency }})
                            </span>
                            · {{ String(suggestion.transaction.date).substr(0, 10) }}
                            · écart {{ suggestion.dayGap }} j
                          </p>
                        </div>
                        <button type="button" @click="applySuggestion(suggestion.transaction)"
                                class="shrink-0 rounded-md border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-1">
                          Associer
                        </button>
                      </li>
                    </ul>
                  </div>

                  <Multiselect
                      v-model="invoiceData.transaction"
                      mode="multiple"
                      valueProp="id"
                      label="label"
                      :close-on-select="true"
                      :searchable="true"
                      :multiple="true"
                      :object="true"
                      :classes="multiselect.classes"
                      :options="transactions"
                      @change="onTransactionsChange"
                  />

                  <div class="grid grid-cols-1 gap-4 mt-2 " v-if="invoiceData.transaction">
                    <div v-for="transaction in invoiceData.transaction" :key="transaction.id"
                         :class="['relative rounded-lg border px-2 py-2 shadow-sm w-full block items-center space-x-3 hover:border-gray-800 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500', isDateDifferenceWarning(transaction.date, invoiceData.date) ? 'bg-yellow-600 border-yellow-700' : 'bg-gray-600 border-gray-700']">
                      <div class="flex-1 min-w-0">
                        <router-link :to="`/transaction/${transaction.id}`" class="focus:outline-none">
                          <span class="absolute inset-0" aria-hidden="true"/>
                          <div class="flex items-center gap-x-4">
                            <img v-if="transaction.company" alt=""
                                 :src="transaction.company.avatar ? transaction.company.avatar : null"
                                 class="h-8 w-8 rounded-full bg-gray-800"/>
                            <div class="truncate text-sm font-medium leading-6 text-white">
                              <p class="text-sm font-medium text-white flex items-center gap-2">
                                {{ transaction.from_name }}
                                <span v-if="isDateDifferenceWarning(transaction.date, invoiceData.date)" class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-200 text-yellow-900" title="Écart de plus de 31 jours entre transaction et facture">
                                  <svg class="h-3 w-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                                  </svg>
                                  Écart {{ getDateDifference(transaction.date, invoiceData.date) }}j
                                </span>
                              </p>

                              <p v-if="transaction.description" class="text-sm text-white truncate">
                                {{ transaction.description }}
                              </p>
                              <p class="text-sm text-white truncate">
                                {{ transaction.amount }} EUR
                                {{
                                  transaction.local_amount != transaction.amount ? `(${transaction.local_amount} ${transaction.local_currency})` : null
                                }}
                              </p>
                              <p class="text-sm text-white truncate">
                                {{ transaction.date }}
                              </p>

                              <p class="text-sm text-white truncate" v-if="transaction.invoice_total < 0 && transaction.invoice_total != transaction.amount">
                                Total attribué sur les factures : {{ transaction.invoice_total }} EUR
                                <br>
                                Solde de la transaction:  {{ transaction.amount - transaction.invoice_total }} EUR
                              </p>
                            </div>

                          </div>

                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-span-2 sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-700">Commentaire</label>
                  <textarea type="text" v-model="invoiceData.comment" @change=postNow
                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                </div>
              </div>
            </div>
            <div class="px-4 py-5 sm:p-5 bg-white border-t border-gray-200" v-if="invoiceData && invoiceData.id">
              <IssuesLinkPanel flat :type="'invoice'" :id="invoiceData.id"
                               :default-title="invoiceData.company ? invoiceData.company.name : ''" />
            </div>
            <div class="px-4 py-5 sm:p-5 bg-white border-t border-gray-200" v-if="invoiceData && invoiceData.id">
              <InventoryPanel flat :invoice-id="invoiceData.id" :company-id="invoiceData.company_id"
                              :invoice-date="invoiceData.date" :line-items="mindeeLineItems" />
            </div>
            <div class="px-4 py-5  sm:p-5 bg-gray-50 border-t border-gray-200 " v-if="invoiceData.logs">

              <div class="grid grid-cols-2 gap-2">
                <div class="col-span-2 sm:col-span-2 ">
                  <ul role="list" class="space-y-6">
                    <li v-for="logs in invoiceData.logs" :key="logs.id"
                        class="relative flex gap-x-4">
                      <div class="absolute left-0 top-0 flex w-6 justify-center">
                        <!--                          :class="[activityItemIdx === activity.length - 1 ? 'h-6' : '-bottom-6', 'absolute left-0 top-0 flex w-6 justify-center']"-->
                        <div class="w-px bg-gray-200"/>
                      </div>
                      <div class="relative flex h-6 w-6 flex-none items-center justify-center">
                        <CheckCircleIcon v-if="logs.event === 'created'" class="h-4 w-4 text-indigo-600"
                                         aria-hidden="true"/>
                        <div v-else class="h-1.5 w-1.5 rounded-full bg-gray-200 ring-1 ring-gray-400"/>
                      </div>
                      <p class="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                        <span class="font-medium text-gray-900">{{
                            logs.user != null ? logs.user.name : "Robot"
                          }} - </span>
                        {{ getTranslation(logs.event) }}
                        <span class="mr-0.5" v-if="logs.properties.length > 0 && logs.event !== 'created'">
                    <template v-for="event in processData(logs.properties)" :key="event.id">
                      <a class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-gray-800 ring-1 ring-inset ring-gray-200 bg-gray-200 ">
                        {{ event }}
                      </a>
                      {{ ' ' }}
                    </template>
                  </span>
                      </p>
                      <time :datetime="logs.created_at.substr(0, 10)"
                            class="flex-none py-0.5 text-xs leading-5 text-gray-500">{{ logs.created_at.substr(0, 10) }}
                      </time>
                    </li>

                  </ul>
                </div>
              </div>
            </div>

            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6" v-if="false">
              <button type="submit"
                      class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Save
              </button>
            </div>


            <div class="px-4 py-5  sm:p-5 bg-gray-50 border-t border-gray-200 " v-if="mindee.document">

              <div class="grid grid-cols-2 gap-2">
                <div class="col-span-2 sm:col-span-2 ">
                  <ul role="list" class="space-y-6">
                    <li v-for="line_item in mindee.document.inference.prediction.line_items"
                        :key="line_item.description"
                        class="relative flex gap-x-4">
                      <div class="absolute left-0 top-0 flex w-6 justify-center">
                        <div class="w-px bg-gray-200"/>
                      </div>
                      <div class="relative flex h-6 w-6 flex-none items-center justify-center">
                        <CheckCircleIcon class="h-4 w-4 text-indigo-600"
                                         aria-hidden="true"/>
                      </div>
                      <p class="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                        {{ line_item.quantity ? line_item.quantity + "x " : "" }} {{ line_item.description }}
                      </p>
                      <time
                          class="flex-none py-0.5 text-xs leading-5 text-gray-500">
                        {{ line_item.total_amount }} {{mindee.document.inference.prediction.locale.currency}}
                      </time>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>


<script setup>
import IssuesLinkPanel from '@/components/board/IssuesLinkPanel.vue';
import InventoryPanel from '@/components/inventory/InventoryPanel.vue';
import {euro} from '@/composables/financeFormat';
import PhoneLineInvoicePanel from '@/components/phone/PhoneLineInvoicePanel.vue';
import {computed, ref} from 'vue'
import {RadioGroup, RadioGroupLabel, RadioGroupOption} from '@headlessui/vue'
import {CheckCircleIcon, ChevronRightIcon, MailIcon, ExclamationCircleIcon, ClipboardCopyIcon} from '@heroicons/vue/solid'
import {NewspaperIcon, InformationCircleIcon, LinkIcon} from '@heroicons/vue/solid'
import {CheckIcon, SelectorIcon} from '@heroicons/vue/solid'
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxLabel,
  ComboboxOption,
  ComboboxOptions,
} from '@headlessui/vue'
import {notify, Notification, NotificationGroup} from 'notiwind'
import {PlusIcon} from '@heroicons/vue/solid'

import {
  EmojiHappyIcon,
  EmojiSadIcon,
  FireIcon,
  HeartIcon,
  PaperClipIcon,
  ThumbUpIcon,
  XIcon as XMoodIcon,
} from '@heroicons/vue/solid'
import {Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions} from '@headlessui/vue'

const activity = [
  {id: 1, type: 'created', person: {name: 'Chelsea Hagon'}, date: '7d ago', dateTime: '2023-01-23T10:32'},
  {id: 2, type: 'edited', person: {name: 'Chelsea Hagon'}, date: '6d ago', dateTime: '2023-01-23T11:03'},
  {id: 3, type: 'sent', person: {name: 'Chelsea Hagon'}, date: '6d ago', dateTime: '2023-01-23T11:24'},
  {
    id: 4,
    type: 'commented',
    person: {
      name: 'Chelsea Hagon',
      imageUrl:
          'https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    comment: 'Called client, they reassured me the invoice would be paid by the 25th.',
    date: '3d ago',
    dateTime: '2023-01-23T15:56',
  },
  {id: 5, type: 'viewed', person: {name: 'Alex Curren'}, date: '2d ago', dateTime: '2023-01-24T09:12'},
  {id: 6, type: 'paid', person: {name: 'Alex Curren'}, date: '1d ago', dateTime: '2023-01-24T09:20'},
]
const moods = [
  {name: 'Excited', value: 'excited', icon: FireIcon, iconColor: 'text-white', bgColor: 'bg-red-500'},
  {name: 'Loved', value: 'loved', icon: HeartIcon, iconColor: 'text-white', bgColor: 'bg-pink-400'},
  {name: 'Happy', value: 'happy', icon: EmojiHappyIcon, iconColor: 'text-white', bgColor: 'bg-green-400'},
  {name: 'Sad', value: 'sad', icon: EmojiSadIcon, iconColor: 'text-white', bgColor: 'bg-yellow-400'},
  {name: 'Thumbsy', value: 'thumbsy', icon: ThumbUpIcon, iconColor: 'text-white', bgColor: 'bg-blue-500'},
  {name: 'I feel nothing', value: null, icon: XMoodIcon, iconColor: 'text-gray-400', bgColor: 'bg-transparent'},
]

const selected = ref(moods[5])
const show = ref(true)

import {XIcon} from '@heroicons/vue/solid'

const mailingLists = [
  {id: 1, title: 'Avec justificatif'},
  {id: 2, title: 'Sans justificatif'},
  {id: 3, title: 'Remboursée'},
]

const selectedMailingLists = ref(mailingLists[0])

</script>

<script>
// import pdfvuer from 'pdfvuer'
import Multiselect from '@vueform/multiselect'
import {useFetch, usePost} from "@/composables/fetch";
import moment from 'moment'
import axios from "axios";

// Company fourre-tout « sans fournisseur » : jamais utilisée pour suggérer des transactions
const FALLBACK_COMPANY_ID = 520

// Écart maximum entre facture et transaction pour supposer une conversion de devise.
// Qonto ne remonte pas toujours le montant d'origine : une facture en dollars n'a alors
// aucun montant identique côté banque, seul le débit en euros après change existe.
const FX_TOLERANCE = 0.12

export default {
  components: {
    // pdf: pdfvuer,
    Multiselect
  },
  props: ['id'],
  data: () => ({
    notifications: "",
    form: {},
    query: ref(''),
    endpoint: 'invoice/',
    companys: [],
    invoiceStatus: [],
    fiscalYears: [],
    transactions: [],
    transactions_reco: {},
    transactions_total_amount: 0,
    status: ref(''),
    changeInProgress: 0,
    previousInvoice: null,
    nextInvoice: null,
    siblingInvoices: [],
    savedSnapshot: null,
    invoiceData: {
      transaction: [],
      company_id: {},
      status: {},
      available_status: [],
    },
    value: [],
    options: [
      {name: 'Vue.js', language: 'JavaScript'},
      {name: 'Adonis', language: 'JavaScript'},
      {name: 'Rails', language: 'Ruby'},
      {name: 'Sinatra', language: 'Ruby'},
      {name: 'Laravel', language: 'PHP'},
      {name: 'Phoenix', language: 'Elixir'}
    ],
    selectedTransaction: ref(''),
    isLoaded: false,
    page: 1,
    numPages: 0,
    pdfdata: undefined,
    mindee: {},
    errors: [],
    polling: null,
    scale: 'page-width',
    multiselect: {
      classes: {
        container: 'mt-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md multiselect',
        containerDisabled: 'is-disabled',
        containerOpen: 'border-indigo-800',
        containerOpenTop: 'border-indigo-800',
        containerActive: 'is-active ring-indigo-500 border-indigo-500  border-gray-300 shadow-sm ',
        singleLabel: 'multiselect-single-label',
        singleLabelText: 'multiselect-single-label-text',
        multipleLabel: 'multiselect-multiple-label',
        search: 'multiselect-search ',
        tags: 'multiselect-tags',
        tag: 'multiselect-tag',
        tagDisabled: 'is-disabled',
        tagRemove: 'multiselect-tag-remove',
        tagRemoveIcon: 'multiselect-tag-remove-icon',
        tagsSearchWrapper: 'multiselect-tags-search-wrapper',
        tagsSearch: 'multiselect-tags-search',
        tagsSearchCopy: 'multiselect-tags-search-copy',
        placeholder: 'multiselect-placeholder',
        caret: 'multiselect-caret',
        caretOpen: 'border-indigo-500',
        clear: 'multiselect-clear',
        clearIcon: 'multiselect-clear-icon',
        spinner: 'multiselect-spinner',
        dropdown: 'multiselect-dropdown',
        dropdownTop: 'is-top',
        dropdownHidden: 'is-hidden',
        options: 'multiselect-options',
        optionsTop: 'is-top',
        group: 'multiselect-group',
        groupLabel: 'multiselect-group-label',
        groupLabelPointable: 'is-pointable',
        groupLabelPointed: 'is-pointed',
        groupLabelSelected: 'is-selected',
        groupLabelDisabled: 'is-disabled',
        groupLabelSelectedPointed: 'is-selected is-pointed',
        groupLabelSelectedDisabled: 'is-selected is-disabled',
        groupOptions: 'multiselect-group-options',
        option: 'multiselect-option',
        optionPointed: 'is-pointed',
        optionSelected: 'is-selected',
        optionDisabled: 'is-disabled',
        optionSelectedPointed: 'is-selected is-pointed',
        optionSelectedDisabled: 'is-selected is-disabled',
        noOptions: 'multiselect-no-options',
        noResults: 'multiselect-no-results',
        fakeInput: 'multiselect-fake-input',
        spacer: 'multiselect-spacer'
      }
    }
  }),
  computed: {
    taxMeta() {
      const parts = [];
      if (this.invoiceData?.tax_rate != null) parts.push(`${Number(this.invoiceData.tax_rate)} %`);
      if (this.invoiceData?.currency) parts.push(this.invoiceData.currency);
      return parts.join(' · ');
    },
    siblingOptions() {
      const list = this.siblingInvoices || [];
      if (this.invoiceData?.id && !list.some((s) => s.id === this.invoiceData.id)) {
        return [{
          id: this.invoiceData.id,
          invoice_id: this.invoiceData.invoice_id,
          company: this.invoiceData.company?.name,
          amount: Number(this.invoiceData.amount),
          date: String(this.invoiceData.date || '').substring(0, 10),
        }, ...list];
      }
      return list;
    },
    mindeeLineItems() {
      const items = this.mindee?.document?.inference?.prediction?.line_items || [];
      return items.map((li) => ({
        description: li.description,
        quantity: li.quantity,
        unit_price: li.unit_price ?? li.total_amount,
      }));
    },
    isTelecomInvoice() {
      const name = (this.invoiceData?.company?.name || "").toLowerCase();
      return /orange|free|sfr|prixtel|red by|bouygues|coriolis|sosh|\bmobile\b/.test(name);
    },
    // Transactions dont le montant est strictement égal à celui de la facture (au centime).
    // Le montant local est aussi comparé : une facture étrangère est saisie dans sa devise.
    transactionSuggestions() {
      const invoiceAmount = this.amountInCents(this.invoiceData?.amount);
      if (!invoiceAmount || !Array.isArray(this.transactions)) return [];

      // Facture déjà entièrement couverte par ses transactions : rien à suggérer
      if (this.amountInCents(this.transactions_total_amount) === invoiceAmount) return [];

      const linkedIds = (this.invoiceData.transaction || []).map((item) => item.id);

      return this.transactions
          .filter((transaction) => !linkedIds.includes(transaction.id))
          .map((transaction) => {
            const amount = Math.abs(this.amountInCents(transaction.amount));
            const localAmount = Math.abs(this.amountInCents(transaction.local_amount));
            const matchedOnLocal = amount !== invoiceAmount && localAmount === invoiceAmount;

            if (amount !== invoiceAmount && !matchedOnLocal) return null;

            return {
              transaction,
              matchedOnLocal,
              dayGap: this.getDateDifference(transaction.date, this.invoiceData.date),
            };
          })
          .filter(Boolean)
          .sort((a, b) => a.dayGap - b.dayGap)
          .slice(0, 5);
    },
    // Même fournisseur, montant proche sans être identique : très probablement la même dépense
    // après conversion de devise. Associer recale la facture sur le montant débité en euros.
    fxTransactionSuggestions() {
      const invoiceAmount = this.amountInCents(this.invoiceData?.amount);
      const companyId = Number(this.invoiceData?.company_id);
      if (!invoiceAmount || !companyId || companyId === FALLBACK_COMPANY_ID) return [];
      if (!Array.isArray(this.transactions)) return [];
      if (this.amountInCents(this.transactions_total_amount) === invoiceAmount) return [];

      const linkedIds = (this.invoiceData.transaction || []).map((item) => item.id);
      const exactIds = this.transactionSuggestions.map((item) => item.transaction.id);

      return this.transactions
          .filter((transaction) => Number(transaction.company_id) === companyId)
          .filter((transaction) => !linkedIds.includes(transaction.id) && !exactIds.includes(transaction.id))
          .filter((transaction) => !(transaction.invoice || []).length)
          .map((transaction) => {
            const amount = Math.abs(this.amountInCents(transaction.amount));
            if (!amount || amount === invoiceAmount) return null;

            const gap = Math.abs(amount - invoiceAmount) / invoiceAmount;
            if (gap > FX_TOLERANCE) return null;

            return {
              transaction,
              gapPercent: (gap * 100).toFixed(1),
              newAmount: (amount / 100).toFixed(2),
              dayGap: this.getDateDifference(transaction.date, this.invoiceData.date),
            };
          })
          .filter(Boolean)
          .sort((a, b) => a.dayGap - b.dayGap)
          .slice(0, 5);
    },
    // Transactions du même fournisseur encore attribuées à aucune facture. Le montant peut
    // différer (acompte, facture partielle, frais) : c'est une piste, pas une correspondance.
    companyTransactionSuggestions() {
      const companyId = Number(this.invoiceData?.company_id);
      if (!companyId || companyId === FALLBACK_COMPANY_ID || !Array.isArray(this.transactions)) return [];

      const linkedIds = (this.invoiceData.transaction || []).map((item) => item.id);
      const alreadySuggestedIds = [
        ...this.transactionSuggestions.map((item) => item.transaction.id),
        ...this.fxTransactionSuggestions.map((item) => item.transaction.id),
      ];

      return this.transactions
          .filter((transaction) => Number(transaction.company_id) === companyId)
          .filter((transaction) => !linkedIds.includes(transaction.id) && !alreadySuggestedIds.includes(transaction.id))
          .filter((transaction) => !(transaction.invoice || []).length)
          .map((transaction) => ({
            transaction,
            dayGap: this.getDateDifference(transaction.date, this.invoiceData.date),
          }))
          .sort((a, b) => a.dayGap - b.dayGap)
          .slice(0, 5);
    },
  },
  created() {
    const scripts = [
      "https://mozilla.github.io/pdf.js/build/pdf.js",
    ];
    scripts.forEach(script => {
      let tag = document.createElement("script");
      tag.setAttribute("src", script);
      document.head.appendChild(tag);
    });
  },
  watch: {
    '$route': {
      handler: function (val, oldVal) {
        clearInterval(this.polling);
        this.fetchInvoiceData();
        this.intervalFetchData()
      },
      immediate: true,
      deep: true
    },
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if (window.pageYOffset <= this.findPos(document.getElementById(p)) || (document.getElementById(p + 1) && window.pageYOffset >= this.findPos(document.getElementById(p + 1)))) {
        window.scrollTo(0, this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    }
  },
  beforeUnmount() {
    clearInterval(this.polling)
  },

  methods: {
    euro,
    siblingLabel(invoice) {
      const parts = [];
      if (invoice.invoice_id) parts.push(`N° ${invoice.invoice_id}`);
      parts.push(invoice.company || '—');
      if (invoice.amount != null) parts.push(euro(invoice.amount));
      if (invoice.date) parts.push(invoice.date);
      return parts.join(' · ');
    },
    goToInvoice(id) {
      if (id && id !== this.invoiceData.id) {
        this.$router.push(`/invoice/${id}`);
      }
    },
    // Comparaison des montants en centimes : les décimales viennent de l'API en chaîne
    amountInCents(value) {
      const parsed = parseFloat(String(value ?? '').replace(/,/g, ''));
      return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
    },
    // @vueform/multiselect émet `change` AVANT `update:modelValue` : sans réappliquer la valeur
    // ici, postNow comparerait encore l'ancienne liste et conclurait qu'il n'y a rien à
    // enregistrer. C'est ce qui empêchait l'ajout (et le retrait) d'une transaction d'être posté.
    async onTransactionsChange(value) {
      this.invoiceData.transaction = Array.isArray(value) ? value : [];
      await this.postNow();
    },
    async applySuggestion(transaction) {
      const linked = Array.isArray(this.invoiceData.transaction) ? this.invoiceData.transaction : [];
      if (linked.some((item) => item.id === transaction.id)) return;

      this.invoiceData.transaction = [...linked, transaction];
      await this.postNow();
    },
    // Facture libellée en devise étrangère : la compta retient le montant réellement débité
    async applyFxSuggestion(suggestion) {
      const oldAmount = parseFloat(this.invoiceData.amount) || 0;
      const oldTax = parseFloat(this.invoiceData.amount_tax) || 0;
      const newAmount = parseFloat(suggestion.newAmount);

      this.invoiceData.amount = newAmount.toFixed(2);
      if (oldAmount && oldTax) {
        this.invoiceData.amount_tax = (oldTax * (newAmount / oldAmount)).toFixed(2);
      }

      await this.applySuggestion(suggestion.transaction);
    },
    isDateDifferenceWarning(transactionDate, invoiceDate) {
      if (!transactionDate || !invoiceDate) return false;
      const diff = Math.abs(moment(transactionDate).diff(moment(invoiceDate), 'days'));
      return diff > 31;
    },
    getDateDifference(transactionDate, invoiceDate) {
      if (!transactionDate || !invoiceDate) return 0;
      return Math.abs(moment(transactionDate).diff(moment(invoiceDate), 'days'));
    },
    copyToClipboard(value, label) {
      if (value === null || value === undefined || value === '') {
        return;
      }
      navigator.clipboard.writeText(String(value)).then(() => {
        notify({
          group: 'bottom',
          title: 'Copié !',
          text: `${label} copié dans le presse-papier.`,
          type: 'success'
        }, 3000);
      });
    },
    processData(logs) {

      let logData = JSON.parse(logs);
      logData.old = undefined;

      const attributes = logData.attributes;
      const old = logData.old;

      let result = [];

      for (const key in attributes) {
        let valueNow, valueOld

        if (Object.prototype.hasOwnProperty.call(attributes, key)) {
          valueNow = attributes[key];
        }

        if (old) {
          if (Object.prototype.hasOwnProperty.call(old, key)) {
            valueOld = old[key];
          }
        }

        if (['id', 'path', 'file_id'].includes(key)) {
          continue
        }


        const oldValue = valueOld === undefined || valueOld === null ? '' : valueOld;
        const newValue = valueNow === undefined || valueNow === null ? '' : valueNow;

        if (oldValue !== newValue)
            // result.push(`${this.getTranslation(key)}: ${oldValue} > ${newValue}`);
          result.push(`${this.getTranslation(key)} `);
      }

      return result;
    },
    getTranslation(word) {
      switch (word) {
        case 'status_id':
          return "status"
        case 'amount':
          return "montant"
        case 'invoice_number':
          return "numero"
        case 'fiscal_year_id':
          return "exercice comptable"
        case 'comment':
          return "commentaire"
        case 'amount_tax':
          return "tva"
        case 'company_id':
          return "fournisseur"
        case 'invoice':
          return "facture"
        case 'created':
          return "Création"
        case 'updated':
          return "Modification"
        case 'company':
          return "fournisseur"
        case 'file':
          return "fichier"
        default:
          return word
      }

    },
    stopPull: function () {
      clearInterval(this.polling);
      this.intervalFetchData()
    },
    intervalFetchData: function () {
      this.polling = setInterval(() => {
        this.fetchInvoiceData();
      }, 8000);
    },
    async postNow() {
      // Les Multiselect/RadioGroup déclenchent postNow sur blur/close/click même sans
      // modification : on ne poste (et ne notifie) que si les données ont vraiment changé
      if (this.savedSnapshot !== null && JSON.stringify(this.invoiceData) === this.savedSnapshot) {
        return;
      }
      this.changeInProgress = true
      const token = await this.$auth.getAccessTokenSilently();
      await usePost(this.endpoint + this.id, this.invoiceData, token)
      await this.fetchInvoiceData();
      this.changeInProgress = false
    },
    async fetchInvoiceData() {
      const token = await this.$auth.getAccessTokenSilently();
      const response = await useFetch(this.endpoint + this.id, token)
      const {
        invoice,
        companys,
        invoiceStatus,
        fiscalYears,
        transactions,
        transactions_reco,
        transactions_total_amount,
        previous_invoice,
        next_invoice,
        sibling_invoices
      } = response.data
      this.previousInvoice = previous_invoice
      this.nextInvoice = next_invoice
      this.siblingInvoices = sibling_invoices || []
      this.fiscalYears = fiscalYears
      this.invoiceStatus = invoiceStatus
      this.isLoaded = true;
      this.status = ref(invoice.status)

      let reco_index = null

      this.companys = companys.map(item => {
        return {
          label: item.name,
          value: item.id,
          icon: item.avatar
        }
      })
      console.log(this.companys);

      transactions.forEach(item => {
        transactions[transactions.indexOf(item)]['label'] = `${item.from_name} ${item.amount} EUR ${item.date.substr(0, 10)}`;
        transactions[transactions.indexOf(item)]['value'] = item.id;
        if (item.from_name) {

          // if (transactions_reco && item.id === transactions_reco.id) {
          //   transactions[transactions.indexOf(item)]['label'] = `=> ${transactions_reco.from_name} ${transactions_reco.amount} EUR ${transactions_reco.date.substr(0, 10)}`;
          //   reco_index = transactions.indexOf(item);
          // } else {
          //   transactions[transactions.indexOf(item)]['label'] = `${item.from_name} ${item.amount} EUR ${item.date.substr(0, 10)}`;
          // }
        }
      });


      invoice.transaction.forEach(item => {
        if (item.from_name) {
          invoice.transaction[invoice.transaction.indexOf(item)]['label'] = `${item.from_name} ${item.amount} EUR ${item.date.substr(0, 10)}`;
        }

      });


      if (invoice.file.mindee_json) {
        this.mindee = JSON.parse(invoice.file.mindee_json);
      }

      this.transactions = transactions
      this.transactions_reco = transactions_reco
      this.invoiceData = invoice
      this.transactions_total_amount = transactions_total_amount
      // Référence pour ignorer les postNow déclenchés sans modification réelle
      this.savedSnapshot = JSON.stringify(this.invoiceData)
    },
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    // async getPdf() {
    //   this.pdfdata = pdfvuer.createLoadingTask('https://billing.clafoutis.eu/api/file/' + this.id);
    //   this.pdfdata.then(pdf => {
    //     this.numPages = pdf.numPages;
    //   });
    // },
  }
}

</script>
<style>

</style>
<style src="@vueform/multiselect/themes/default.css"></style>
